const SELECTORS = {
    postsContainer: '.wp-block-ssm-interactive-map__posts',
    postCard: '.post-card',
};

export class PostMapLink {
    constructor(block, viewToggle) {
        this.block = block;
        this.viewToggle = viewToggle;
        this.handlePostClick = this.handlePostClick.bind(this);
        this.init();
    }

    init() {
        this.container = this.block.querySelector(SELECTORS.postsContainer);
        if (!this.container) return;
        this.container.addEventListener('click', this.handlePostClick);
    }

    handlePostClick(e) {
        if (this.viewToggle.currentView !== 'map') return;

        const card = e.target.closest(SELECTORS.postCard);
        if (!card) return;

        const postId = parseInt(card.dataset.postId, 10);
        if (!postId) return;

        if (typeof window.FWP_MAP === 'undefined' || !FWP_MAP.map_loaded) return;

        const markers = FWP_MAP.get_post_markers(postId);
        if (!markers.length) return;

        e.preventDefault();

        const marker = markers[0];

        FWP_MAP.map.panTo(marker.position);
        FWP_MAP.map.setZoom(12);
        google.maps.event.trigger(marker, 'spider_click');
    }

    destroy() {
        this.container?.removeEventListener('click', this.handlePostClick);
    }
}
